
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/daily-rent/[[...params]]",
      function () {
        return require("private-next-pages/daily-rent/[[...params]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/daily-rent/[[...params]]"])
      });
    }
  